const AlertPayment = {
  label: {
    unpaid: 'Nenhum pagamento informado no sistema, se atente a data de vencimento.',
    pending: 'Pagamento informado pelo usuário, aguardando confirmação pelo comprovante de quitação.',
    paid: 'Pagamento confirmado, comprovante de quitação díponivel.'
  }
};

export default AlertPayment;
